export default {
    view: {
        title: 'Trend Summary'
    }
}
